import { UserInfo } from '../model';

const ALLOWED_ROLES = ['STORE_MANAGER', 'MANAGER'];

export const isStoreManager = (userInfo: UserInfo) => {
  return userInfo.employeeRole === 'STORE_MANAGER';
};

export const isManager = (userInfo: UserInfo) => {
  return userInfo.employeeRole === 'MANAGER';
};

export const isNewUser = (userInfo: UserInfo) => {
  return !userInfo.employeeRole;
};

export const hasAllowedRole = (userInfo: UserInfo) => {
  return userInfo.employeeRole && ALLOWED_ROLES.includes(userInfo.employeeRole);
};

export const hasNotAllowedRole = (userInfo: UserInfo) => {
  return !hasAllowedRole(userInfo);
};
